import api from './interceptor';

const BASE_URL_V1 = 'api/v1/appointment';

export default {
  // API Version 1
  getReasonsForVisit: params => api.get(`${BASE_URL_V1}/reasonsForVisit/`, { params }),
  // API Version 2
};
